import { Box, Button, Modal, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface ApiErrorModalProps {
  open: boolean;
  message: string;
  status?: number;
  onClose: () => void;
}

const modalBoxSx = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 420,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 4,
  textAlign: 'center' as const,
  outline: 'none',
};

export function ApiErrorModal({ open, message, status, onClose }: ApiErrorModalProps) {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="api-error-title">
      <Box sx={modalBoxSx}>
        <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main', mb: 1.5 }} />

        <Typography id="api-error-title" variant="h6" fontWeight={700} gutterBottom>
          {status ? `Error ${status}` : 'Request Failed'}
        </Typography>

        <Typography color="text.secondary" sx={{ mt: 1, mb: 4 }}>
          {message}
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={onClose}
          fullWidth
          sx={{ borderRadius: '8px' }}
        >
          Dismiss
        </Button>
      </Box>
    </Modal>
  );
}
